import styled from "styled-components"

export const TopMenu = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 9999;
  margin: 0 auto;
  background: #000;
  max-width: 1020px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px,
    rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;

  .image-logo {
    width: 330px;
    height: 95px;
    margin: 2px;
  }

  .logo-name {
    font-size: 40px;
  }

  .logo {
    display: flex;
    position: relatve;
    margin: 0 auto;
    height: 100px;
    max-width: 315px;
  }

  .top-menu {
    display: none;
  }

  .closed-menu {
    display: none;
  }

  ul {
    list-style-type: none;
    margin: 0 auto;
  }

  .footer-menu {
    position: absolute;
    bottom: 0;
  }

  a {
    color: #fff;
    text-decoration: none;
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (min-width: 1025px) {
    min-width: 100vw;
    display: flex;
    justify-content: center;
   
    .home-button {
      display: none;
    }

    .container-top-menu{
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 1000px;
    }

    .logo {
      display: flex;
      margin: 0;
      width: 300px;
      height: 100px;
    }

    .top-menu {
      right: 0;
      display: flex;
      align-items: center;
      justify-content: end;
      height: 0px;
      width: 450px;
      margin-top: 0px;
    }
  }
`

export const BottomMenu = styled.div`
  position: fixed;
  width: 100%;
  height: 65px;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  margin: 0px auto;
  background: #000;
  box-shadow: 0px 0px 0px #d5d8dc, 0px -5px 5px #d5d8dc;

  ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    list-style-type: none;
  }

  a {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
  }

  @media (min-width: 1025px) {
    display: none;
  }
`
